import { createAction } from '@reduxjs/toolkit';

export const preference = {
    toggleLight: createAction('preference/toggleLight'),
};
